import { render, staticRenderFns } from "./TechRoomPolygonViewer.vue?vue&type=template&id=f78cc1ac"
import script from "./TechRoomPolygonViewer.vue?vue&type=script&lang=js"
export * from "./TechRoomPolygonViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports